module.exports = __webpack_public_path__ + "img/demo1.9f48b843.png";